import { useProfileStore } from '@/store/useProfileStore'
import type { User } from '@supabase/supabase-js'

export async function primeAvatarOnLogin(u: User) {
  try {
    const providerUrl = (u.user_metadata?.avatar_url as string) || ''

    if (providerUrl) {
      try { useProfileStore.getState().setLocalAvatar(providerUrl) } catch {}
    }

    const attemptFetch = async () => {
      try { await useProfileStore.getState().fetchAvatarUrl() } catch {}
      const url = useProfileStore.getState().avatarUrl
      return !!url
    }

    let gotSigned = await attemptFetch()
    if (!gotSigned) {
      const delays = [1000, 3000, 5000]
      for (const d of delays) {
        await new Promise((r) => setTimeout(r, d))
        gotSigned = await attemptFetch()
        if (gotSigned) break
      }
    }
  } catch {
    // silent
  }
}